import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.0.4_@babel+core@7.26.9_@playwright+test@1.50.1_babel-plugin-macros@3.1.0_react-dom@18_dl3mykepryykume7n4z6ubruam/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/scalis-components/core/navbar/navbar-template/navbar-template.tsx");
